export const iconFontAwesomeBuildingsBuildingUser = (
	<i className="fa-solid fa-building-user"></i>
);
